import { render, staticRenderFns } from "./EditableItem.vue?vue&type=template&id=64b30946&scoped=true&"
import script from "./EditableItem.vue?vue&type=script&lang=js&"
export * from "./EditableItem.vue?vue&type=script&lang=js&"
import style0 from "./EditableItem.vue?vue&type=style&index=0&id=64b30946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b30946",
  null
  
)

export default component.exports